import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { formatNumber, parseNumber } from "widgets/inputs";

import styles from "./style.css";

export function Number(props) {
  const { value, column } = props;
  const decimal =
    column.Decimalpoint ||
    (column.modelConfig && column.modelConfig.Decimalpoint);
  const formattedValue = useMemo(
    function formatValue() {
      return formatNumber(parseNumber(value), decimal);
    },
    [decimal, value]
  );
  return value !== null ? (
    <span className={`${styles.text} ${styles.right}`}>{formattedValue}</span>
  ) : (
    ""
  );
}

Number.propTypes = {
  value: PropTypes.any,
  column: PropTypes.any
};
